import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import HotelIcon from "@mui/icons-material/Hotel";

const API = process.env.REACT_APP_API_URL;

const RoomBedManager = ({ open, onClose, onSuccess }) => {
  const navigate = useNavigate();
  const [roomNumber, setRoomNumber] = useState("");
  const [capacity, setCapacity] = useState("");

  const createRoom = async () => {
    if (!roomNumber || !capacity) {
      toast.error("Enter room number and capacity");
      return;
    }
    const loadingToast = toast.loading("Loading...");
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API}hostel/rooms/`,
        {
          room_number: roomNumber,
          capacity: parseInt(capacity),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      toast.dismiss(loadingToast);
      toast.success("Room created and beds generated automatically!");
      onSuccess?.();
      onClose?.();
      navigate("/admin/dashboard");
    } catch (err) {
      toast.dismiss(loadingToast);
      if (err.response?.data) {
        const errorData = err.response.data;

        const roomError = errorData?.room_number?.[0]?.toLowerCase();
        if (
          roomError &&
          (roomError.includes("already exists") ||
            roomError.includes("room number"))
        ) {
          toast.error("Room number already exists!");
          return;
        }

        const firstField = Object.keys(errorData)[0];
        toast.error(errorData[firstField]?.[0] || "Failed to create room");
      } else {
        const errorData = err?.response?.data;
        const firstField = Object.keys(errorData)[0];
        toast.error(errorData[firstField]?.[0] || "Failed to create room");
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className="flex items-center justify-between">
        <span className="flex items-center gap-2 text-xl font-semibold text-primaryText">
          <HotelIcon className="text-primaryColor" />
          Add Hostel Room
        </span>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers className="space-y-4">
        <TextField
          label="Room Number/name"
          variant="outlined"
          fullWidth
          value={roomNumber}
          onChange={(e) => setRoomNumber(e.target.value)}
        />
        <TextField
          label="Capacity"
          type="number"
          variant="outlined"
          fullWidth
          value={capacity}
          onChange={(e) => setCapacity(e.target.value)}
        />
      </DialogContent>

      <DialogActions className="px-6 pb-4">
        <Button onClick={onClose} variant="outlined" color="inherit">
          Cancel
        </Button>
        <Button onClick={createRoom} variant="contained" color="primary">
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RoomBedManager;
